const hubspotKeys = {
  all: ["hubspot"] as const,
  listLenders: () => [...hubspotKeys.all, "list", "lenders"],
  leadSources: () => [...hubspotKeys.all, "lead-sources"],
};

export { hubspotKeys };
